import React from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import FormInputField from "@/components/lib/from-input-field";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";

function SupportHelp() {
  const form = useForm({
    resolver: zodResolver(securitySchema),
    defaultValues: {
      currentPin: "",
      newPin: "",
      confirmPin: "",
    },
  });
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <div className="px-4 flex flex-col gap-2">
        <h1 className="text-lg font-semibold text-cwhite mb-3">
          {" "}
          Support & Help Center
        </h1>
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem className="bg-cblack4" value="item-1">
            <AccordionTrigger className="px-2 text-cwhite2">
              Login Issues
            </AccordionTrigger>
            <AccordionContent className="text-cwhite3 px-2 space-y-2">
              <li className="list-none">
                1. Incorrect username or password will prevent login—make sure
                the credentials are correct.
              </li>
              <li className="list-none">
                2. If you forgot your password, use the "Forgot Password" option
                to reset it.
              </li>
              <li className="list-none">
                3. Login may be blocked if the account is inactive or the
                subscription has expired.
              </li>
              <li className="list-none">
                4. Without an active internet connection, the software may not
                allow login.
              </li>
              <li className="list-none">
                5. If the issue persists after checking these, please contact
                the support team.
              </li>
              <li className="list-none">
                6. Login problems can also occur during software updates or
                server downtime.
              </li>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        <Accordion type="single" collapsible className="w-full">
          <AccordionItem className="bg-cblack4" value="item-1">
            <AccordionTrigger className="px-2 text-cwhite2">
              Sales Issues
            </AccordionTrigger>
            <AccordionContent className="text-cwhite3 px-2 space-y-2">
              <li className="list-none">
                1. Slow or failed sales entry may happen due to poor internet or
                device lag.
              </li>
              <li className="list-none">
                2. If you forgot your password, use the "Forgot Password" option
                to reset it.
              </li>
              <li className="list-none">
                3. Incorrect product or price can occur if the item isn’t
                properly set in the system.
              </li>
              <li className="list-none">
                4. Discounts or tax not applying could indicate wrong settings
                in the POS configuration..
              </li>
              <li className="list-none">
                5. If the sales don’t sync with reports, check the internet and
                sync status.
              </li>
              <li className="list-none">
                6. For unresolved issues, please contact support with details
                and screenshots.
              </li>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        <Accordion type="single" collapsible className="w-full">
          <AccordionItem className="bg-cblack4" value="item-1">
            <AccordionTrigger className="px-2 text-cwhite2">
              Print Issues
            </AccordionTrigger>
            <AccordionContent className="text-cwhite3 px-2 space-y-2">
              <li className="list-none">
                1. Make sure the printer is properly connected via USB,
                Bluetooth, or network (Wi-Fi/LAN).
              </li>
              <li className="list-none">
                2. Install the correct driver based on your printer model and
                operating system.
              </li>
              <li className="list-none">
                3. In the POS settings, select the default printer and test a
                sample receipt.
              </li>
              <li className="list-none">
                4. Check paper size and format settings to avoid printing errors
                or cut-off text.
              </li>
              <li className="list-none">
                5. If the issue persists after checking these, please contact
                the support team.
              </li>
              <li className="list-none">
                6. For advanced setup or troubleshooting, contact support with
                the printer model name.
              </li>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        <div className="flex flex-col gap-5 mt-5">
          <h2 className="font-semibold text-cwhite2">Have any Question ?</h2>
          <div>
            <Form {...form}>
              <form
                className="max-w-lg w-full space-y-5"
                onSubmit={form.handleSubmit('')}
              >
                <FormInputField
                  name="title"
                  placeholder="Title here"
                  form={form}
                  type="text"
                  style="bg-cblack3"
                  label={"Title"}
                />
                <FormInputField
                  name="message"
                  placeholder="Write your message"
                  form={form}
                  type="textarea"
                  style="bg-cblack3 h-28"
                  label={"Message"}
                />
       
                <Button className="bg-cgreen">Submit</Button>
              </form>
            </Form>
          </div>
        </div>
      </div>
    </Layout2>
  );
}

export default SupportHelp;

const securitySchema = z.object({
  currentPin: z.string().min(6, "Password must be at least 6 characters long"),
  newPin: z.string().min(6, "invalid"),
  confirmPin: z.string().min(6, "invalid"),
});
